module.exports = __webpack_public_path__ + "img/logo_EC_TiU_trans.63445e7e.svg";